export type { StructuredClinicalSummary } from './schema';
export {
  GoogleVertexClinicalSummarySchema,
  StructuredClinicalSummarySchema,
} from './schema';
